import { dialogStore } from "@ucl/library";
import { DialogProps } from "../../../../../Dialogs/Dialog/Dialog";
import { GridMetricsPickerForm } from "./GridMetricsPickerForm";
import { GridMetricOptionValueReadDTO } from "../types";

const dialogIdBase = "grid-metrics-picker-dialog";

const getDialogId = (): string => `${dialogIdBase}`;

const buildGridViewPickerDialog = (
  viewId: string,
  updateViewMetricSettings: (
    viewId: string,
    metricSettings: string[]
  ) => Promise<void>,
  fetchMetricOptionValues: () => Promise<void | GridMetricOptionValueReadDTO[]>,
  metricConfiguration: string[]
): DialogProps => {
  return {
    id: getDialogId(),
    className: dialogIdBase,
    header: "Metrics Footer Configuration",
    allowDragging: false,
    content: () => (
      <div>
        <GridMetricsPickerForm
          viewId={viewId}
          metricConfiguration={metricConfiguration}
          updateViewMetricSettings={updateViewMetricSettings}
          fetchMetricOptionValues={fetchMetricOptionValues}
        />
      </div>
    ),
  };
};
export const openGridMetricsPickerDialog = (
  viewId: string,
  updateViewMetricSettings: (
    viewId: string,
    metricSettings: string[]
  ) => Promise<void>,
  fetchMetricOptionValues: () => Promise<void | GridMetricOptionValueReadDTO[]>,
  metricConfiguration: string[]
) =>
  dialogStore.openDialog(
    buildGridViewPickerDialog(
      viewId,
      updateViewMetricSettings,
      fetchMetricOptionValues,
      metricConfiguration
    )
  );

export const closeGridMetricsPickerDialog = () =>
  dialogStore.closeDialog(getDialogId());
